// extracted by mini-css-extract-plugin
module.exports = {"sideBarItem":"SidebarItem_sideBarItem__LOL8p","label":"SidebarItem_label__KEm_X","icon":"SidebarItem_icon__tL49A","active":"SidebarItem_active__UGI_0"};